module.exports = __webpack_public_path__ + "static/media/recipient-template-mvp.ff6aea4e.xlsx";